import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";

const ReportGenerate = () => {
  const [transId, setTransId] = useState("");

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const access_token = localStorage.getItem("cejoraTokenDash");
  const headers = {
    Authorization: `Bearer ${access_token}`,
  };

  const userReportGenerateHandler = async (e) => {
    e.preventDefault();

    // axios
    //   .get(baseUrl + `user-find-download`, { id: transId }, { headers })
    //   .then((res) => {
    //   })
    //   .catch((err) => {
    //   });

    try {
      const response = await fetch(baseUrl + `user-find-download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
        body: JSON.stringify({ id: transId }),
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${transId}_history.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  return (
    <>
      <div className="">
        <h4 className="font-weight-bold my-3">All USER REPORT GENERATE</h4>
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card text-white">
              <div className="card-body text-light">
                <h4 className="card-title">Generate Report</h4>

                {/* searching */}
                <form onSubmit={userReportGenerateHandler}>
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <input
                        type="text"
                        placeholder="Enter User Id..."
                        className="form-control col-sm-4 m-2"
                        onChange={(e) => setTransId(e.target.value)}
                        value={transId}
                      />
                    </div>
                    <div className="col-md-2">
                      <button className="btn btn-danger">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportGenerate;
